import { render, staticRenderFns } from "./LabelSetActivities.vue?vue&type=template&id=99cb64bc&scoped=true&"
import script from "./LabelSetActivities.vue?vue&type=script&lang=js&"
export * from "./LabelSetActivities.vue?vue&type=script&lang=js&"
import style0 from "./LabelSetActivities.vue?vue&type=style&index=0&id=99cb64bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cb64bc",
  null
  
)

export default component.exports